/**
 * Single source for platform API base URL (REACT_APP_PLATFORM_API_BASE_URL).
 * No fallbacks; use requirePlatformApiBaseUrl() where missing must throw.
 */

export function normalizeBaseUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim().replace(/\/+$/, '');
  if (trimmed.includes('.local') && trimmed.startsWith('https://')) {
    return trimmed.replace('https://', 'http://');
  }
  return trimmed;
}

export function getPlatformApiBaseUrl() {
  const raw = process.env.REACT_APP_PLATFORM_API_BASE_URL;
  return normalizeBaseUrl(raw ?? '');
}

export function requirePlatformApiBaseUrl() {
  const base = getPlatformApiBaseUrl();
  if (!base) {
    throw new Error('Missing REACT_APP_PLATFORM_API_BASE_URL');
  }
  return base;
}
